<template>
  <request-form @submit.prevent="doSubmit">
    <date-browse-item label="依頼日" :value="requestAt" />
    <div v-if="this.infoAcquired">
      <div v-if="this.buildingSearchType === 0">
        <vuex-building-form-item bind="building_id" :options="buildings" :required="true" @change="doChangeBuilding" />
      </div>
      <div v-else-if="this.buildingSearchType === 1 || this.buildingSearchType === 2">
        <vuex-building-text-form-item bind="building_id"
                                      :options="buildings"
                                      :required="true"
                                      :placeholder="isBuildingSearchWordCount + '文字以上入力してください'"
                                      :minlength="isBuildingSearchWordCount"
                                      :searchType="buildingSearchType"
                                      @select="doChangeBuilding"
        />
      </div>
    </div>
    <info-alert-browse-item v-if="building_outline" label="" :message="building_outline" />
    <vuex-text-form-item label="依頼物件住戸番号" bind="building_house_number" :required="true" />
    <vuex-text-form-item label="所有者" bind="owner_name" :required="true" />
    <info-alert-browse-item v-if="ownerNameExplanation" label="" :message="ownerNameExplanation" />
    <div v-show="requiredDocumentOption !== 2">
      <vuex-document-upload-form-item :required="!isOwner" :isOwner="isOwner" :required-document-option="requiredDocumentOption" />
      <info-alert-browse-item v-if="requiredDocumentExplanation" label="" :message="requiredDocumentExplanation" />
    </div>
    <vuex-issue-document-form-item bind="issue_documents" :issue-documents="issueDocuments" :required="true" />
    <info-alert-browse-item v-if="issueDocumentExplanation" label="" :message="issueDocumentExplanation" />
    <text-browse-item label="手数料の支払方法" :value="paymentMethodName" />
    <vuex-textarea-form-item label="備考" bind="note" />
    <text-browse-item v-if="!isOwner" label="会社名" :value="company.name" />
    <vuex-text-with-button-form-item v-if="isOwner" label="依頼者住所" bind="owner_address" :required="true">
      <template #append>
        <button type="button" class="btn btn-outline-secondary" @click="copyToCompanyAddress">物件住所取得</button>
      </template>
    </vuex-text-with-button-form-item>
    <text-browse-item v-else label="会社住所" :value="companyAddress" />
    <vuex-textarea-form-item label="連絡先" bind="contact" :required="true" />
    <licence-browse-item v-if="!isOwner" label="免許番号" :type="company.licence_type" :number="company.licence_number" />
    <info-alert v-if="wholeExplanation" :message="wholeExplanation" />
  </request-form>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import {convertPrefectureCodeToName} from '@/constants/prefecture';
import {convertPaymentMethodToName} from '@/constants/payment_method';
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent';
import RequestForm from "@/views/templates/forms/RequestForm";
import DateBrowseItem from "@/views/molecules/browseItems/DateBrowseItem";
import VuexBuildingFormItem from '@/views/molecules/formItems/VuexBuildingFormItem';
import VuexBuildingTextFormItem from '@/views/molecules/formItems/VuexBuildingTextFormItem';
import VuexTextFormItem from "@/views/molecules/formItems/VuexTextFormItem";
import VuexDocumentUploadFormItem from "@/views/molecules/formItems/VuexDocumentUploadFormItem";
import VuexIssueDocumentFormItem from '@/views/molecules/formItems/VuexIssueDocumentFormItem';
import TextBrowseItem from "@/views/molecules/browseItems/TextBrowseItem";
import VuexTextareaFormItem from "@/views/molecules/formItems/VuexTextareaFormItem";
import LicenceBrowseItem from "@/views/molecules/browseItems/LicenceBrowseItem";
import InfoAlertBrowseItem from "@/views/molecules/browseItems/InfoAlertBrowseItem";
import InfoAlert from "@/views/atoms/alerts/InfoAlert";
import VuexTextWithButtonFormItem from "@/views/molecules/formItems/VuexTextWithButtonFormItem";

export default {
  name: "IssuanceRequestRegister",
  components: {
    RequestForm,
    DateBrowseItem,
    VuexBuildingFormItem,
    VuexBuildingTextFormItem,
    VuexTextFormItem,
    VuexDocumentUploadFormItem,
    VuexIssueDocumentFormItem,
    TextBrowseItem,
    VuexTextareaFormItem,
    LicenceBrowseItem,
    InfoAlertBrowseItem,
    InfoAlert,
    VuexTextWithButtonFormItem,
  },
  inject: [
    '$constant',
  ],
  mixins: [AddonLoadPageEvent],
  provide: {
    bindModule: 'issuance_request_form'
  },
  computed: {
    ...mapState('issuance_request_form', {
      buildings: state => state.buildings,
      building_outline: state => state.data.building.building_outline,
      issueDocuments: state => state.issueDocuments,
      requestAt: state => state.data.request_at,
      payment_method_code: state => state.data.payment_method,
      requiredDocumentOption: state => state.data.building.management_company.required_document_option,
      requesterContact: state => state.data.contact,
      ownerNameExplanation: state => state.data.owner_name_explanation,
      requiredDocumentExplanation: state => state.data.required_document_explanation,
      issueDocumentExplanation: state => state.data.issue_document_explanation,
      wholeExplanation: state => state.data.whole_explanation,
    }),
    ...mapState('account', {
      isGuest: state => state.is_guest,
      company: state => state.company,
      accountContact: state => state.contact,
      guestIssuanceRequestId: state => state.guest.issuance_request_id,
      guestType: state => state.guest_type,
    }),
    ...mapState('login_form', {
      buildingSearchType: state => state.building_search_type,
      buildingSearchWordCount: state => state.building_search_word_count,
      infoAcquired: state => state.info_acquired,
    }),
    companyAddress() {
      return convertPrefectureCodeToName(this.company.prefecture_code) + this.company.address1 + (this.company.address2 ?? '');
    },
    paymentMethodName() {
      return convertPaymentMethodToName(this.payment_method_code);
    },
    confirmRouteName() {
      return this.isGuest ? 'GuestIssuanceRequestRegisterConfirm' : 'IssuanceRequestRegisterConfirm';
    },
    isOwner() {
      return this.guestType === this.$constant.GUEST_TYPE.OWNER.code;
    },
    isBuildingSearchWordCount() {
      if (this.buildingSearchWordCount >= 1) {
        return this.buildingSearchWordCount;
      } else {
        return 0;
      }
    },
  },
  beforeRouteLeave(to) {
    if (!to.name.match(/^(Guest)?IssuanceRequestRegisterConfirm$/)) {
      // 遷移先が想定された場所以外なら入力内容をリセットする
      this.resetData();
    }
  },
  methods: {
    ...mapMutations('issuance_request_form', [
      'resetData',
      'setWarning',
      'setContact',
      'setIsOwner',
    ]),
    async loadPage() {
      // ページロード時にフォームのデータをリセット
      if (this.isGuest){
        await this.$store.dispatch('account/authGuest', {
          access_key: sessionStorage.getItem('accessKey')
        }).catch((reason) => this.$root.failApi(reason));
        if (this.guestIssuanceRequestId !== null) {
          // ゲストですでに発行依頼が申請されていれば、発行依頼詳細画面に遷移
          return this.$router.replace({name: 'GuestIssuanceRequestViewer'});
        }
      }

      // Vue コンポーネントの isOwner をストアに設定
      if (this.isOwner){
        this.setIsOwner(this.isOwner);
      }
      // モジュール内にデータがなければ取得（リロードしたときはデータが入っていないので再読み込みする）
      this.$store.dispatch('login_form/load', {
        mccd: localStorage.getItem('managementCompanyCode'),
        register_entry: true,
      }).catch((reason) => this.$root.failApi(reason));

      if (this.buildings.length > 0) { //すでに物件選択済みの場合
        return true;
      }
      // 連絡先の初期値を設定
      this.setContact(this.accountContact);

      const payload = {
        management_company_code: localStorage.getItem('managementCompanyCode'),
        name: null,
        name_kana: null,
        prefecture_code: null,
        address1: null,
        is_guest: this.isGuest
      };
      return this.$store.dispatch('issuance_request_form/loadBuildings', payload).catch(reason => {
        if (reason?.notFound) {
          this.setWarning({key: 'building_id', value: ['依頼できる物件が存在しません。']});
        } else {
          this.$root.failApi(reason);
        }
      });
    },
    async doChangeBuilding(buildingId) {
      if (this.isGuest){
        await this.$store.dispatch('account/authGuest', {
          access_key: sessionStorage.getItem('accessKey')
        }).catch((reason) => this.$root.failApi(reason));
      }
      if (buildingId) {
        const payload = {
          building_id: buildingId,
          is_guest: this.isGuest,
        }
        this.$store.dispatch('issuance_request_form/loadIssueDocuments', payload).catch((reason) => this.$root.failApi(reason));
      } else {
        // 物件の選択で空欄を選択した場合
        this.$store.commit('issuance_request_form/setIssueDocuments', []);
        this.$store.commit('issuance_request_form/resetBuildingOutline');
        this.$store.commit('issuance_request_form/setPaymentMethod',null);
        this.$store.commit('issuance_request_form/setBuildingRelatedInfo',null);
      }
    },
    async doSubmit() {
      if (this.isGuest){
        await this.$store.dispatch('account/authGuest', {
          access_key: sessionStorage.getItem('accessKey')
        }).catch((reason) => this.$root.failApi(reason));
      }
      this.$store.dispatch('issuance_request_form/validate').then(() => {
        this.$router.push({name: this.confirmRouteName});
      }).catch(() => {});
    },

    async copyToCompanyAddress() {
      const buildingId = this.$store.state.issuance_request_form.data.building_id;
      const buildingName = this.$store.state.issuance_request_form.data.building.name;
      const houseNumber = this.$store.state.issuance_request_form.data.building_house_number;      
      const selectedBuilding = this.$store.state.issuance_request_form.buildings.find(building => building.id === buildingId);
      const address = selectedBuilding?.address ?? '';

      // いずれも存在しない場合は空白にして終了
      if (!buildingName && !houseNumber && !address) {
        await this.$store.commit('issuance_request_form/inputFormItem', {
          column: 'owner_address',
          value: '',
        });
        return;
      }
      // 存在する要素のみを結合
      const combinedAddress = [address, buildingName, houseNumber].filter(Boolean).join(' ');
      // 非同期処理で更新
      await this.$store.commit('issuance_request_form/inputFormItem', {
        column: 'owner_address',
        value: combinedAddress,
      });
    },
  }
}
</script>
